module.exports = __webpack_public_path__ + "static/media/search.7d2d8a65.svg";